logo = document.getElementById("logo-home")
visible = true;


window.onscroll = function() {
  scrollFunction()
};

function scrollFunction() {
    // console.log(document.body.scrollTop);
    // console.log(document.documentElement.scrollTop);
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop >20) {
    if (visible) { 
      fade(logo); 
      visible = false; 
    }

  } else {

    if (!visible) { 
      unfade(logo); 
      visible = true; 
    }


  }
}


function unfade(element) {
  var op = 0.1;
  element.style.display = 'flex';
  var timer = setInterval(function() {
    if (op >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op += op * 0.1;
  }, 10);
}


function fade(element) {
  var op = 1; 
  var timer = setInterval(function() {
    if (op <= 0.1) {
      clearInterval(timer);
      element.style.display = 'none';
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op -= op * 0.1;
  },10);
}